import { SystemIcon, getSvgFromSystem } from '@helpers/systemIcons';
import * as React from 'react';
import S from './MobileNavigation.styles';
import { findFirstFocusableElementAfter } from '@helpers/navigation';
const MobileNavigation = ({ activePage = '', isOpen, links, loginLink, myAccountLink, searchTerm, searchResultsUrl, searchResultsPlaceholder, promotion, searchTermSet, }) => {
    const [stack, setStack] = React.useState([]);
    const containerRef = React.useRef(null);
    // Reset state if navigation is toggled.
    React.useEffect(() => {
        if (isOpen) {
            setStack([]);
        }
    }, [isOpen]);
    React.useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape' && containerRef.current) {
                const nextFocusable = findFirstFocusableElementAfter(containerRef.current);
                if (nextFocusable) {
                    event.preventDefault();
                    nextFocusable.focus();
                }
            }
        };
        if (isOpen && containerRef.current) {
            containerRef.current.addEventListener('keydown', handleKeyDown);
        }
        return () => {
            if (containerRef.current) {
                containerRef.current.removeEventListener('keydown', handleKeyDown);
            }
        };
    }, [isOpen]);
    // Render top level navigation...
    if (stack.length === 0) {
        return renderDefault();
    }
    // ...or current level.
    return renderLevel(stack[stack.length - 1]);
    /**
     * Render the top-level layout.
     * @returns
     */
    function renderDefault() {
        return (React.createElement(S.Container, { "data-m-active": isOpen, "aria-hidden": !isOpen, "aria-label": "Main Navigation", ref: containerRef },
            React.createElement(S.ListArea, null,
                React.createElement(S.SearchForm, null,
                    React.createElement(S.SearchLabel, null, "Search For:"),
                    React.createElement(S.SearchInput, { placeholder: searchResultsPlaceholder ?? '', type: "search", value: searchTerm, onChange: (event) => {
                            searchTermSet(event.target.value);
                        }, onKeyDown: (e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                handleRedirect();
                            }
                        } }),
                    React.createElement(S.SearchSubmit, { type: "submit", onClick: handleRedirect }, getSvgFromSystem(SystemIcon.Search))),
                React.createElement(S.List, null, links.map((item) => (React.createElement(S.Item, { key: item.id },
                    React.createElement(S.Link, { href: item.page.url, target: item.page.target ?? '_self', id: item.page.id, tabIndex: isOpen ? 0 : -1, "data-active-page": activePage === item.id, onClick: (event) => {
                            if (item.sectionLinks) {
                                event.preventDefault();
                                push(item);
                            }
                        } },
                        React.createElement(S.Text, null, item.page.text),
                        !!item.sectionLinks?.length && React.createElement(S.Arrow, null)))))),
                React.createElement(S.LinkArea, null,
                    !!promotion && (React.createElement(S.MemberLink, { href: promotion.link.url, target: promotion.link.target ?? '_self', id: promotion.link.id }, promotion.heading)),
                    loginLink?.url && (React.createElement(S.LoginLink, { href: loginLink?.url, target: loginLink?.target ?? '_self', id: loginLink.id },
                        React.createElement("span", null, loginLink?.text),
                        " ",
                        getSvgFromSystem(SystemIcon.Login))),
                    myAccountLink?.url && (React.createElement(S.LoginLink, { href: myAccountLink?.url, target: myAccountLink?.target ?? '_self', id: myAccountLink.id },
                        React.createElement("span", null, myAccountLink?.text),
                        " ",
                        getSvgFromSystem(SystemIcon.Login)))))));
    }
    /**
     * Render the layout for the current active item (last in stack).
     * @returns
     */
    function renderLevel(activeItem) {
        return (React.createElement(S.Container, { "data-m-active": isOpen, "data-sub-level": stack.length > 0, "data-component-theme": activeItem.theme, ref: containerRef },
            React.createElement(S.Header, null,
                React.createElement(S.Back, { onClick: (event) => {
                        event.preventDefault();
                        pop();
                    } },
                    React.createElement(S.BackSvg, null),
                    React.createElement("span", null, "Back")),
                React.createElement(S.Link, { href: activeItem.page.url, target: activeItem.page.target },
                    React.createElement(S.Text, null,
                        React.createElement("span", null, activeItem.page.text)))),
            React.createElement(S.List, null, activeItem.sectionLinks &&
                activeItem.sectionLinks.map((item) => (React.createElement(S.Item, { key: item.id },
                    React.createElement(S.ChildLink, null,
                        React.createElement(S.Link, { href: item.url, target: item.target, "data-active-page": activePage === item.id },
                            React.createElement(S.Text, null,
                                React.createElement("span", null, item.text))))))))));
    }
    function handleRedirect() {
        if (!searchTerm || searchTerm.length === 0) {
            return;
        }
        window.location.href = `${searchResultsUrl}?searchTerm=${searchTerm}`;
    }
    /**
     * Push navigation item to stack.
     * @param item
     */
    function push(item) {
        const newStack = [...stack, item];
        setStack(newStack);
    }
    /**
     * Pop last item from stack.
     * @param item
     */
    function pop() {
        const newStack = stack.slice(0, stack.length - 1);
        setStack(newStack);
    }
};
export default MobileNavigation;
